import Button from "../Button";

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  language = false,
}) => {
  const pages = [...Array(totalPages).keys()].map((n) => n + 1);

  return (
    <nav aria-label="Pagination">
      <ul className="inline-flex items-center -space-x-px text-sm">
        <li>
          <Button
            disabled={currentPage === 1}
            onClick={() => onPageChange(currentPage - 1)}
            className="px-3 py-1.5 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700"
          >
            {language ? "पिछला" : "Prev"}
          </Button>
        </li>
        {pages.map((page) => (
          <li key={page}>
            <button
              onClick={() => onPageChange(page)}
              className={`px-3 py-1.5 leading-tight border ${
                currentPage === page
                  ? "text-white bg-btn"
                  : "text-gray-500 bg-white hover:bg-gray-100 hover:text-gray-700"
              }`}
            >
              {page}
            </button>
          </li>
        ))}
        <li>
          <Button
            disabled={currentPage === totalPages}
            onClick={() => onPageChange(currentPage + 1)}
            className="px-3 py-1.5 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700"
          >
            {language ? "अगला" : "Next"}
          </Button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
